"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Returns a Date object plus x days
 * @param days
 * @return {Date}
 */
exports.default = (days = 0) => {
    const date = new Date();
    date.setDate(date.getDate() + days);
    return date;
};
